/**
 * 搜索结果 URL 工具函数
 * 集中管理 URL 相关的处理逻辑
 */

/**
 * 从 URL 获取 favicon 地址
 * @param url 目标 URL
 * @returns favicon 地址，如果无效返回 null
 */
export function getFaviconUrl(url: string): string | null {
  try {
    const u = new URL(url);
    return `${u.origin}/favicon.ico`;
  } catch {
    return null;
  }
}

/**
 * 从 URL 提取域名名称
 * @param url 目标 URL
 * @returns 域名名称（不含 www.），如果无效返回 URL 前 30 个字符
 */
export function getDomainName(url: string): string {
  try {
    const u = new URL(url);
    return u.hostname.replace('www.', '');
  } catch {
    return url.slice(0, 30);
  }
}

/**
 * 检测 URL 是否有效
 * @param url 目标 URL
 * @returns 是否有效
 */
export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

/**
 * 清理 URL 中的跟踪参数
 * @param url 目标 URL
 * @returns 清理后的 URL
 */
export function cleanTrackingParams(url: string): string {
  try {
    const u = new URL(url);
    const paramsToRemove = ['utm_', 'fbclid', 'gclid', 'msclkid', 'ref', 'source', 'campaign'];
    
    paramsToRemove.forEach(param => {
      [...u.searchParams.keys()].forEach(key => {
        if (key.startsWith(param)) {
          u.searchParams.delete(key);
        }
      });
    });
    
    return u.toString();
  } catch {
    return url;
  }
}
